import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import { ConnectedInstructionPane as RootComponent } from './ConnectedInstructionPane';
import { rootReducer } from './reducers';
import { InstructionPaneContext } from './reduxHooks';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const store = createStore(rootReducer, applyMiddleware(reduxThunk));
export const InstructionPaneProvided = props => ___EmotionJSX(Provider, {
  context: InstructionPaneContext,
  store: store
}, ___EmotionJSX(RootComponent, _extends({}, props, {
  key: String(props.exerciseId)
})));